var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepBox"},[_c('qiangzhi',{attrs:{"type":3}}),_c('div',{staticClass:"step"},[_c('fengxian'),_c('InspectSearch',{attrs:{"ismode":""}})],1),_c('fuwu',{attrs:{"type":2}}),_c('mElectronicFooter',{attrs:{"disabledNext":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }